import React, {useState} from "react";
import { getProfileDetails } from "@/services/profiles";
import { BygrProfileDetails, ProfileMember } from "@/types";
import { useAsyncStateWithIsLoading } from "@/utils/hooks";
import theme from "./LinkProjectModal.module.scss";
import { ProfileIcon, UserIcon } from "@ygtechnologies/bygr-frontend-component-library";
import { searchByFields } from "@/utils/search";
import { Checkbox, ButtonBar, AlertBanner, Button } from '@ygtechnologies/rubus-ui';

interface ProjectLinkedProjectProps {
    profileId: number | null;
    searchText: string;
    toggle: () => void;
    onSelect: (members: ProfileMember[]) => void;
    onBack: () => void;
}

export const memberSort = (a: ProfileMember, b: ProfileMember) => {
    if (a.isAdmin && !b.isAdmin) {
        return -1;
    } else if (!a.isAdmin && b.isAdmin) {
        return 1;
    } else {
        return a.userName.localeCompare(b.userName);
    }
}

const ProjectLinkedProject: React.FC<ProjectLinkedProjectProps> = ({profileId, searchText, toggle, onSelect, onBack}) => {
    const [profile, , , isLoading] = useAsyncStateWithIsLoading<BygrProfileDetails | null>(() => getProfileDetails(profileId as number), [profileId], null);
    const [checkedMembers, setCheckedMembers] = useState<Record<string, boolean>>({});

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCheckedMembers({...checkedMembers, [e.target.name]: e.target.checked});
    }

    const handleSelect = () => {
        const members = profile?.members.filter((member) => checkedMembers[member.userId]) as ProfileMember[];
        onSelect(members);
    }

    const enableNext = Object.keys(checkedMembers).some((key) => checkedMembers[key]);

    if (!profile) {
        return isLoading ? <div>Loading...</div> : <div>No profile found</div>;
    }

    return (
        <div>
            <AlertBanner type="warning">
                Selected users will be added as admins in the sub-project.
            </AlertBanner>
            <ul className={theme.list}>
                {searchByFields(profile.members.sort(memberSort), searchText, ['userName', 'email']).map((member) => (
                    <li key={member.userId}>
                        <div className={theme.participantWrapper}>
                            <ProfileIcon profileIconUrl="" sizeInPx={36} className={theme.companyIcon} />
                            <div className={theme.icons}>
                                <UserIcon avatarThumbnailUrl="" sizeInPx={24} className={theme.employeeIcon} />
                            </div>
                            <div className={theme.userInfo}>
                                <div>{member.userName}{member.isAdmin && (" (admin)")}</div>
                                <div className={theme.companyRole}>{member.email}</div>
                            </div>
                        </div>

                        <div className={theme.checkbox}>
                            <Checkbox inputSize="md" 
                                name={member.userId.toString()} 
                                checked={checkedMembers[member.userId]} 
                                onChange={handleChange} 
                            />
                        </div>
                    </li>
                ))}
            </ul>
            <ButtonBar>
                <Button onClick={toggle} variant="tertiary">
                    Cancel
                </Button>
                <Button onClick={onBack} variant="tertiary">
                    Back
                </Button>
                <Button onClick={handleSelect} disabled={!enableNext} variant="primary">
                    Next
                </Button>
            </ButtonBar>
        </div>
    );
};

export default ProjectLinkedProject;
